module.exports = __webpack_public_path__ + "img/qilin-f-stage2-hungry.6798b6ec.png";